import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { useOptionalStreamerContext } from '../routes/streamer/streamer-context';

export type SongTitleLinkProps = {
  // Null on a live learn and on anything else the streamer never added to
  // their list, which is exactly the case that has no page to link to.
  songId: number | null;
  className?: string;
  children: ReactNode;
};

/**
 * The title of a queued or played song, pointed at that song's page whenever
 * there is one. Outside the streamer layout -- an isolated test, an embed --
 * there is no streamer to build the path from, so the title stays plain rather
 * than linking somewhere that would not resolve.
 */
export function SongTitleLink({ songId, className, children }: SongTitleLinkProps) {
  const streamer = useOptionalStreamerContext();

  if (songId == null || !streamer) {
    return <span className={className}>{children}</span>;
  }

  return (
    <Link
      to={`/${streamer.routePrefix}/${streamer.currentUsername}/songs/${songId}`}
      className={className ? `${className} hover:underline` : 'hover:underline'}
    >
      {children}
    </Link>
  );
}
